import React, { useEffect } from "react";
import { X } from "lucide-react";

const DemoVideoModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="SmileReveal walkthrough video"
    >
      <div
        className="relative w-full max-w-3xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close video"
          className="absolute top-3 right-3 z-10 flex items-center justify-center w-9 h-9 rounded-full bg-white/90 text-slate-900 hover:bg-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <iframe
          src="https://www.loom.com/embed/dbfe1a1c088c4d14906fb5eb94a6b38f?autoplay=1&hide_owner=true&hide_share=true&hideEmbedTopBar=true"
          title="SmileReveal walkthrough video"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          className="absolute inset-0 w-full h-full"
        />
      </div>
    </div>
  );
};

export default DemoVideoModal;
